// forceUpload — pure helper dla ForceUploadButton (Sprint #2).
//
// Wyciągnięte z ForceUploadButton.jsx do osobnego .js żeby było testowalne
// przez node:test bez JSX transformer.
//
// 3 redundantne triggery na wywołanie:
//   1. uploadManager.trigger()                — lokalny tab natychmiast
//   2. uploadManager.requestBackgroundSync()  — register photo-sync (Android Chrome)
//   3. SW postMessage TRIGGER_SYNC            — broadcast do innych otwartych tabów
//
// LEKCJA #38 (incydent rano 04.05 [D-F]): Background Sync drzemiące. Android
// Chrome PWA standalone optymalizuje baterii czekając na "dobre warunki" przed
// sync. Internet OK ≠ sync odpali. UI trigger button = self-service workaround.

/**
 * R2b-d (monit 1215, 19.08): zwraca PROMISE lokalnego przebiegu kolejki —
 * ForceUploadButton czeka na realny wynik zamiast udawać sukces timerem
 * („✓ Wysłane" po 3 s przy 9 wiszących zdjęciach — incydent D.Tyrek).
 *
 * @param {Object} deps
 * @param {Object} [deps.uploadManager] - { trigger, requestBackgroundSync }
 * @param {Object} [deps.sw]            - navigator.serviceWorker (lub null)
 * @returns {Promise<void>} rozwiązuje się po zakończeniu lokalnego przebiegu
 */
export function forceUpload({ uploadManager: um, sw }) {
  // 1. Lokalny tab — natychmiast process queue (promise pełnego przebiegu)
  const localPass = um?.trigger ? Promise.resolve(um.trigger()) : Promise.resolve();
  // 2. Background Sync register — Chrome/Android, no-op iOS
  if (um?.requestBackgroundSync) {
    um.requestBackgroundSync().catch(() => {});
  }
  // 3. Broadcast do innych tabów (np. admin ma 2 karty)
  if (sw?.controller?.postMessage) {
    try {
      sw.controller.postMessage({ type: 'TRIGGER_SYNC', source: 'manual-button' });
    } catch {
      // PostMessage może rzucić jeśli SW jest detached — non-fatal
    }
  }
  return localPass;
}
